import { render } from "./ResponseList.vue?vue&type=template&id=87925a90&scoped=true"
import script from "./ResponseList.vue?vue&type=script&lang=js"
export * from "./ResponseList.vue?vue&type=script&lang=js"

import "./ResponseList.vue?vue&type=style&index=0&id=87925a90&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87925a90"]])

export default __exports__